import React from 'react';
import './pr-img-icon.scss';

export default class PrImgIconComponent extends React.Component {
  render() {
    return (
      <div
        className={`pr-img-icon-wrapper ${this.props.type}`}
        onClick={this.props.onClick ? this.props.onClick : () => {/*default empty function*/}}
      >
        <img src={this.props.url} alt=""></img>
      </div>
    );
  }
}
